import { render, staticRenderFns } from "./TankDetails.vue?vue&type=template&id=1cbd1340&"
import script from "./TankDetails.vue?vue&type=script&lang=js&"
export * from "./TankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports